/**
 * Typewriter — efeito de digitação em elementos [data-typewriter].
 * Preserva a marcação interna (<br> e <em>). Sem dependências.
 * Respeita prefers-reduced-motion (mantém o texto completo).
 */
(function () {
    function tokenize(el) {
        var tokens = [];
        el.childNodes.forEach(function (node) {
            if (node.nodeType === 3) {
                for (var i = 0; i < node.textContent.length; i++) tokens.push({ t: "c", ch: node.textContent[i], em: false });
            } else if (node.nodeName === "BR") {
                tokens.push({ t: "br" });
            } else if (node.nodeName === "EM") {
                for (var j = 0; j < node.textContent.length; j++) tokens.push({ t: "c", ch: node.textContent[j], em: true });
            } else {
                for (var k = 0; k < node.textContent.length; k++) tokens.push({ t: "c", ch: node.textContent[k], em: false });
            }
        });
        return tokens;
    }

    function esc(ch) {
        return ch === "&" ? "&amp;" : ch === "<" ? "&lt;" : ch === ">" ? "&gt;" : ch;
    }

    function build(tokens, count) {
        var html = "";
        var openEm = false;
        for (var i = 0; i < count; i++) {
            var tk = tokens[i];
            if (tk.t === "br") { if (openEm) { html += "</em>"; openEm = false; } html += "<br>"; continue; }
            if (tk.em && !openEm) { html += "<em>"; openEm = true; }
            if (!tk.em && openEm) { html += "</em>"; openEm = false; }
            html += esc(tk.ch);
        }
        if (openEm) html += "</em>";
        return html;
    }

    function run(el) {
        var tokens = tokenize(el);
        var total = tokens.length;
        if (!total) return;

        el.classList.add("tw-typing");
        el.innerHTML = '<span class="tw-caret" aria-hidden="true"></span>';

        var i = 0;
        function step() {
            i++;
            el.innerHTML = build(tokens, i) + '<span class="tw-caret" aria-hidden="true"></span>';
            if (i < total) {
                var tk = tokens[i - 1];
                var delay = 28; // mais rápido → menos tempo com o h1 "incompleto" (Speed Index)
                if (tk.t === "br") delay = 6;
                else if (tk.ch === " ") delay = 16;
                setTimeout(step, delay);
            } else {
                el.classList.remove("tw-typing");
                el.classList.add("tw-done");
            }
        }
        step();
    }

    function init() {
        var els = document.querySelectorAll("[data-typewriter]");
        if (!els.length) return;
        var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        if (reduce) return; // mantém o texto completo
        els.forEach(run);
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", init);
    } else {
        init();
    }
})();
